// The stats API can return either numeric totals or abbreviated strings (e.g. 3K).
export const formatLibraryCount = (value) => {
	if (typeof value === "string") {
		const count = value.trim();
		if (/^\d+(?:\.\d+)?[KMBT]$/i.test(count) && parseFloat(count) > 0) return count.toUpperCase();
		if (!/^\d+$/.test(count)) return null;
		value = Number(count);
	}
	return Number.isSafeInteger(value) && value > 0 ? value.toLocaleString() : null;
};
